export default __webpack_public_path__ + "static/media/instagram_1.80ef4b6a.png";